interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  tone?: "light" | "dark";
  as?: "h2" | "h3";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  tone = "light",
  as = "h2",
}: SectionHeadingProps) {
  const alignClass = align === "center" ? "text-center items-center" : "text-left items-start";
  const titleColor = tone === "dark" ? "text-background-50" : "text-foreground-950";
  const descColor = tone === "dark" ? "text-background-300/90" : "text-foreground-600";
  const eyebrowColor = tone === "dark" ? "text-accent-300" : "text-primary-600";
  const Tag = as;

  return (
    <div className={`flex flex-col ${alignClass}`}>
      {eyebrow && (
        <span
          className={`inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase font-label ${eyebrowColor}`}
        >
          <span
            className={`w-6 h-px ${tone === "dark" ? "bg-accent-400" : "bg-primary-400"}`}
          ></span>
          {eyebrow}
        </span>
      )}
      <Tag
        className={`mt-4 font-heading text-2xl md:text-[2rem] font-bold leading-snug ${titleColor}`}
      >
        {title}
      </Tag>
      {desc && (
        <p className={`mt-4 max-w-2xl text-[15px] leading-relaxed ${descColor}`}>{desc}</p>
      )}
    </div>
  );
}